import { Button, MaskedInput, Select, ArticleHeading1, ArticleParagraph1, useDeviceInfo } from '@cian/ui-kit';
import cn from 'clsx';

import { DealsLeadFormResultModal } from '../DealsLeadFormResultModal';
import { DealsLegalCheck } from '../DealsLegalCheck';
import * as s from './DealsLeadForm.css';
import { caShowCpdForm } from '../../utils/analytics/cpdDeals/trackingCpdDeals';
import { useDealsLeadFormFields } from 'shared/hooks/useDealsLeadFormFields';
import { useTrackCpdDealsShow } from 'shared/hooks/useTrackCpdDealsShow';
import type { IDealsLeadFormRegionOption } from 'shared/types/dealsForm';

export interface IDealsLeadFormProps {
  title: string;
  subtitle: string;
  regionOptions: IDealsLeadFormRegionOption[];
}

/** Пропсы блока формы в статье: подводка + сама форма */
export interface IDealsLeadFormBlockProps extends IDealsLeadFormProps {
  leadIn: string;
}

/**
 * Форма заявки продукта "Циан Сделки"
 */
export const DealsLeadForm = ({ title, subtitle, regionOptions }: IDealsLeadFormProps) => {
  const { isPhone } = useDeviceInfo();
  const formRef = useTrackCpdDealsShow(caShowCpdForm);
  const { phoneProps, selectProps, isAgreementChecked, resultModalProps, handleAgreementChange, submitButtonProps } =
    useDealsLeadFormFields({ source: 'magazineForm' });

  return (
    <div ref={formRef} className={cn(s['wrapper'], isPhone && s['wrapper-mobile'])}>
      <div className={s['decor-image']} />

      <div className={s['header']}>
        <ArticleHeading1 color="white_100">{title}</ArticleHeading1>
        <ArticleParagraph1 color="white_100">{subtitle}</ArticleParagraph1>
      </div>

      <div className={s['fields-row']}>
        <MaskedInput {...phoneProps} />
        <Select {...selectProps} options={regionOptions} />
        <Button size="M" theme="fill_white_primary" {...submitButtonProps}>
          Перезвоните мне
        </Button>
      </div>

      <DealsLegalCheck
        inverted
        checked={isAgreementChecked}
        onCheckedChange={handleAgreementChange}
        withMarketingAgreement
      />

      <DealsLeadFormResultModal {...resultModalProps} />
    </div>
  );
};

/** Подводка + форма заявки для вставки в статью */
export const DealsLeadFormBlock = ({ leadIn, ...formProps }: IDealsLeadFormBlockProps) => {
  return (
    <div className={s['block-wrapper']}>
      <p className={s['lead-in']}>{leadIn}</p>
      <DealsLeadForm {...formProps} />
    </div>
  );
};
